import { Component, OnInit, ViewContainerRef, OnDestroy } from '@angular/core';
import {Action} from 'app/clmtlk/shared/model/action';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Impersonate } from 'app/clmtlk/shared/model/impersonate';
import {ClmtlkService} from 'app/clmtlk/shared/service/clmtlk.service';
import { Router, ActivatedRoute } from '@angular/router';
import {SessionStorage} from 'ngx-webstorage';
import { GoogleAnalyticsService } from 'app/common/service/google-analytics.service';
import { Conversation, ConversationContextWrapper,
  ActionLog, Message, ConversationContact } from 'app/clmtlk/shared/model/conversationContacts';
import * as ServerObj from 'app/clmtlk/shared/model/serverObjects';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { ToastrService } from 'ngx-toastr';
import { BlockUIService } from 'ng-block-ui';

@Component({
  selector: 'clmtlk-thread',
  templateUrl: './thread.component.html',
  styleUrls: ['./thread.component.scss']
})
export class ThreadComponent implements OnInit, OnDestroy {


    action: Action;
    ACTION = Action;
    newImpersonate: Impersonate;
    @SessionStorage('token') private token;
    conversation: Conversation;
    response: ServerObj.Response;

   constructor(private modalService: NgbModal,
    private clmtlkService: ClmtlkService,
    private clmtlkSessionService: ClmtlkSessionService,
    private toastrService: ToastrService,
    private blockUIService: BlockUIService,
    private route: ActivatedRoute,
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService) {
    }

  ngOnInit() {
    console.info("clmtlkSessionService",this.clmtlkSessionService);
    // Google Analytics
    this.route.params.subscribe(params => {
          this.googleAnalyticsService.trackPage(
            `/conv/${params['conv_id']}/thread/${params['thrd_id']}/?a=${this.clmtlkSessionService.authToken}`);
    });



    const conversationContext: ConversationContextWrapper = this.clmtlkSessionService.getConversationContext();
    if (conversationContext && conversationContext !== null &&
            (conversationContext.action === Action.VIEWMESSAGE ||
            conversationContext.action === Action.CANCEL_NEWCONVERSATION) ) {

        this.conversation = conversationContext.conversation;
        if (conversationContext.action === Action.VIEWMESSAGE) {
          this.clmtlkSessionService.setConversationContext(null, null, null);
          this.showSuccessOrWarningMessage();
        }

    } else {
        this.fetchThreadDetails();

    }

  }


  backToInbox(event) {
    if (!(this.clmtlkSessionService.pinCode && this.clmtlkSessionService.pinCode != null) && this.clmtlkSessionService.getOldPin()) {
      this.clmtlkSessionService.pinCode = this.clmtlkSessionService.getOldPin();
    }
    this.router.navigateByUrl('/inbox');
  }

  replyClick(event) {
    this.clmtlkSessionService.setConversationContext('EXISTING_THREAD_CONVERSATION', this.conversation, Action.REPLY);
    this.router.navigate(['/message', 'reply']);
  }

  replyAllClick(event) {
    this.clmtlkSessionService.setConversationContext('EXISTING_THREAD_CONVERSATION', this.conversation, Action.REPLYALL);
    this.router.navigate(['/message', 'replyall']);
  }

  fetchThreadDetails() {
    this.blockUIService.start('main', 'Loading Message Details... please wait');
    this.route.params
    .flatMap(params => {
      const conv_id = params['conv_id'];
      const thrd_id = params['thrd_id'];
      return this.clmtlkService.getThreadDetails(conv_id, thrd_id);
    }).subscribe(
      result => {
          this.conversation = result;
          this.blockUIService.stop('main');
      },
      error => {
        this.blockUIService.stop('main');
        this.toastrService.error(error, 'Loading Message Details failed',
        { closeButton: true, positionClass: 'toast-top-full-width', tapToDismiss: false , timeOut: 0});
      }
    );
  }

  showSuccessOrWarningMessage() {
    const message: Message[] = this.conversation.conversationThreads.conversationThread[0].
    threads.thread[0].threadMessages.threadMessage[0].messages.message;
    const actionLogs: ActionLog[] = message[0].actionLogs && message[0].actionLogs.actionLog;
    const convContacts: ConversationContact[] = message[0].conversationContacts.conversationContact;
    const convContIds: number[] = [];
    const successMsg = 'Successfully sent a Message';
    let errorMsg = '';
    if ( actionLogs && actionLogs != null ) {
        actionLogs.forEach(actionLog => {
          if (actionLog.ACTN_STS_CD === 'failure' && convContIds.indexOf(actionLog.CONV_CTC_ID) === -1) {
            convContacts.forEach((convContact, index) => {
              // tslint:disable-next-line:triple-equals
              if (convContact.CONV_CTC_ID == actionLog.CONV_CTC_ID) {
                  convContIds.push(convContact.CONV_CTC_ID);
                  errorMsg = errorMsg + ((errorMsg === '') ? ' ' : ' , ') + convContact.contacts.contact[0].CTC_NM
                  + ((this.clmtlkSessionService.loggedInContact.CTC_SRC_CD === 'st')
                  ? '- ' + convContact.contacts.contact[0].CTC_VAL_TXT : '');
              }
            });
          }
      });
    }

    if (errorMsg === '') {
      //SP 2018-08-24 Added in setTimeout. Otherwise getting a ExpressionChangedAfterItHasBeenCheckedError
      //this.toastrService.info('Successfully sent a Message', 'Message Sent');
      setTimeout(() => this.toastrService.info('Successfully sent a Message', 'Message Sent'));
    }else {
      //this.toastrService.warning('Push Notification message failed for contacts : ' + errorMsg, 'Message Sent')
      setTimeout(() => this.toastrService.warning('Push Notification message failed for contacts : ' + errorMsg, 'Message Sent'));
    }
  }

  ngOnDestroy(): void {
    this.toastrService.clear();
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/thread/thread.component.ts